import { useState } from 'react';

import { generatePassword } from '../lib/passwordGenerator';
import { inputClass } from './TextField';

interface Props {
  label?: string;
  value: string;
  onChange: (value: string) => void;
}

/** Поле пароля с кнопками «Сгенерировать» (9 симв., см. generatePassword) и «Скопировать». */
export function GeneratedPasswordField({ label = 'Пароль', value, onChange }: Props) {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    if (!value) return;
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      // буфер обмена недоступен (нет HTTPS/разрешения) — пароль всё равно виден в поле.
    }
  };

  return (
    <label className="block text-sm">
      <span className="mb-1 block font-medium text-ink/80">{label}</span>
      <div className="flex flex-wrap gap-2">
        <input
          className={`${inputClass} flex-1`}
          style={{ minWidth: '10rem' }}
          type="text"
          autoComplete="new-password"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Сгенерируйте или введите пароль"
        />
        <button
          type="button"
          onClick={() => onChange(generatePassword())}
          className="shrink-0 rounded-lg border border-line bg-surface px-3 py-2 text-sm text-ink hover:bg-canvas"
        >
          Сгенерировать
        </button>
        <button
          type="button"
          onClick={copy}
          disabled={!value}
          className="shrink-0 rounded-lg border border-line bg-surface px-3 py-2 text-sm text-ink hover:bg-canvas disabled:opacity-40"
        >
          {copied ? 'Скопировано' : 'Скопировать'}
        </button>
      </div>
    </label>
  );
}
